/* DistCenterStatusRenderer.js */

"use strict";
//const _ = require("lodash");

class DistCenterStatusRenderer {
    constructor(model) {
        this._model = model;
        this._feed = undefined;

        this._rootElem = document.createElement("file-server-status");
        this._staticText = document.createElement("span");
        this._statusEl = document.createElement("div");
        this._staticText.className = "center-status-label";
        this._statusEl.className = "center-status-container";

        this._registerListeners();
    }
    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/
    _registerListeners() {
        this.model.on("DSGUpdate", (this._onUpdate = this._onUpdate.bind(this)));
    }
    _unregisterListeners() {}

    _onUpdate(message) {
        let mArea = document.createElement("span");
        mArea.innerHTML = message;
        if (message === "Connected") {
            mArea.className = "status connected";
        } else {
            mArea.className = "status disconnected";
        }
        this._statusEl = mArea;
        this.render();
    }
    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    shutdown() {
        this._unregisterListeners();
        this._rootElem.remove();

        this._model = undefined;
        this._rootElem = undefined;
        this._staticText = undefined;
        this._statusEl = undefined;

        return Promise.resolve();
    }
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        this._rootElem.innerHTML = "";
        this._staticText.innerHTML = "Gluware Distribution Center Status: ";
        this._staticText.className = "label";
        this._rootElem.appendChild(this._staticText);
        this._rootElem.appendChild(this._statusEl);
        return Promise.resolve();
    }

    getRootElement() {
        return this._rootElem;
    }
    get rootElement() {
        return this.getRootElement();
    }

    getModel() {
        return this._model;
    }
    get model() {
        return this.getModel();
    }
    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START PRIVATE RENDER METHODS */
    /*******************************************/
    /**
     *
     * @param {OsImageServerEntity[]} serverData
     * @private
     */
    /*
    _updateServerStatus(serverData = []) {
        this._serverContainer.innerHTML = "";

        if (_.isEmpty(serverData)) {
            let message = document.createElement("span");
            message.className = `no-servers`;
            message.innerHTML = "No servers available";
            this._serverContainer.appendChild(message);
        } else {
            serverData.forEach((server) => {
                let domItem = document.createElement("span"),
                    serverStatusKey = server.status || "NOT_INSTALLED",
                    serverStatusMapped =
                        this.IMAGE_SERVER_STATUSES[serverStatusKey] || "NOT INSTALLED",
                    serverDiscUsage = server.percentFull ? server.percentFull + "%" : "unknown",
                    serverName = server.name;
                domItem.className = `server-name ${serverStatusKey}`;
                domItem.title =
                    serverStatusMapped !== "NOT INSTALLED"
                        ? `${serverStatusMapped} - Disk Usage: ${serverDiscUsage}`
                        : serverStatusMapped;
                domItem.innerText = serverName;
                this._serverContainer.appendChild(domItem);
            });
        }
    }
     */
    /*******************************************/
    /* END PRIVATE RENDER METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/

    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}
module.exports = DistCenterStatusRenderer;
